import axios from "axios";

const Url = process.env.REACT_APP_URl;

export const getAgents = async (name: any) => {
    const apiUrl = Url + "/findgent";
    const response = await axios.post(apiUrl, { name: name }, {
        headers : {   
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}

export const getProfileAgent = async (userId: any) => {
    const apiUrl = Url + "/get_Profile";
    const response = await axios.post(apiUrl, { userId: userId }, {
        headers : {   
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}

export const AddAgentServ = async (obj: any) => {
    const apiUrl = Url + "/addAgent";
    const response = await axios.post(apiUrl, obj, {
        headers : {   
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}

export const UpdateAgentServ = async (id: any, obj: any) => {
    const apiUrl = Url + "/updateagent";
    const response = await axios.put(apiUrl + "/" + id, obj, {
        headers : {   
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}
export const DeleteAgentServ = async (id: any) => {
    const apiUrl = Url + "/deleteagent";
    const response = await axios.delete(apiUrl + "/" + id, {
        headers : {   
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}
export const GetAgentServ = async () => {
    const apiUrl = Url + "/getAgents";
    const response = await axios.get(apiUrl, {
        headers : {   
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}

export const GetNumbersOfListings = async (email: any) => {
    const apiUrl = Url + "/getnumberoflistings";
    const response = await axios.post(apiUrl, { email: email }, {
        headers : {   
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}

export const UploadCsvAgents = async (file: File) => {
    const formData = new FormData();
    formData.append("file", file);
    const apiUrl = Url + "/upload-csv";
    const response = await axios.post(apiUrl, formData, {
        headers : {   
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}